import { Link, Outlet } from 'react-router-dom';

import Meta from "../../components/Meta";
import Header from "../../components/Header";

import List from './List';
import CreateWalletPackageForm from './forms/CreateWalletPackage.form';
import UpdateWalletPackageForm from './forms/UpdateWalletPackage.form';

function Template() {
	return (
		<>
			<Meta title="Wallet Packages" />
			<Header heading={"Wallet Packages"} button={<Link to="create" className="btn btnPrimary">+ Create Package</Link>} />
			<main>
				<Outlet />
			</main>
		</>
	);
}

export default {
	Template,
	List,
	Create: CreateWalletPackageForm,
	Update: UpdateWalletPackageForm
};
